/**
 * Platform detection utility for PWA push notifications
 */
export const getPlatformInfo = () => {
  const { userAgent } = navigator;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isMacOS = /Mac/.test(userAgent);
  const isAndroid = /Android/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  const isApplePlatform = isIOS || (isMacOS && isSafari);

  return {
    isIOS,
    isMacOS,
    isAndroid,
    isSafari,
    isApplePlatform,
    supportsWebPush:
      !isApplePlatform &&
      'serviceWorker' in navigator &&
      'PushManager' in window
  };
};

/**
 * Get the appropriate platform identifier for push notifications
 */
